import { FloatingDock } from './components/ui/floating-dock'
import { 
  IconHome,
  IconCode,
  IconBrain,
  IconBrandGithub,
  IconBrandLinkedin,
  IconBriefcase 
} from '@tabler/icons-react';
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { Home } from './components/Home';
import Projects from './components/Projects';
import Skills from './components/Skills';
import { Experience } from './components/Experience';
import { AuroraBackground } from './components/ui/aurora-background';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [activePath, setActivePath] = useState('/');

  useEffect(() => {
    // Enable dark mode by default
    document.documentElement.classList.add('dark');
  }, []);

  const handleNavigation = (path) => {
    if (path === '/') {
      setCurrentPage('home');
      setActivePath('/');
    } else if (path === '/projects') {
      setCurrentPage('projects');
      setActivePath('/projects');
    } else if (path === '/skills') {
      setCurrentPage('skills');
      setActivePath('/skills');
    } else if (path === '/experience') {
      setCurrentPage('experience');
      setActivePath('/experience');
    } else if (path.startsWith('https://')) {
      window.open(path, '_blank');
    }
  };

  const navigationItems = [
    {
      title: "Home",
      icon: <IconHome className="w-full h-full" />,
      href: "/"
    },
    {
      title: "Projects",
      icon: <IconCode className="w-full h-full" />,
      href: "/projects"
    },
    {
      title: "Skills",
      icon: <IconBrain className="w-full h-full" />,
      href: "/skills"
    },
    {
      title: "Experience",
      icon: <IconBriefcase className="w-full h-full" />,
      href: "/experience"
    },
    {
      title: "GitHub",
      icon: <IconBrandGithub className="w-full h-full" />,
      href: "https://github.com/Aakarsh911"
    },
    {
      title: "LinkedIn",
      icon: <IconBrandLinkedin className="w-full h-full" />,
      href: "https://linkedin.com/in/aakarsh-kaushal"
    }
  ];

  const renderPage = () => {
    const variants = {
      enter: {
        x: 20,
        opacity: 0
      },
      center: {
        x: 0,
        opacity: 1
      },
      exit: {
        x: -20,
        opacity: 0
      }
    };

    return (
      <AnimatePresence mode="wait">
        <motion.div
          key={currentPage}
          initial="enter"
          animate="center"
          exit="exit"
          variants={variants}
          transition={{
            x: { type: "spring", stiffness: 300, damping: 30 },
            opacity: { duration: 0.2 }
          }}
        >
          {(() => {
            switch (currentPage) {
              case 'home':
                return <Home />;
              case 'projects':
                return <Projects />;
              case 'skills':
                return <Skills />;
              case 'experience':
                return <Experience />;
              default:
                return <Home />;
            }
          })()}
        </motion.div>
      </AnimatePresence>
    );
  };

  return (
    <div className="min-h-screen w-full relative antialiased bg-neutral-950">
      <div className="absolute inset-0 w-full h-full">
        <AuroraBackground className="w-full h-full fixed" />
      </div>
      <div className="relative z-10">
        {renderPage()}
        <FloatingDock 
          items={navigationItems.map(item => ({
            ...item,
            onClick: () => handleNavigation(item.href)
          }))}
          activePath={activePath}
          desktopClassName="!fixed bottom-8 left-1/2 -translate-x-1/2"
          mobileClassName="!fixed bottom-8 right-8"
        />
      </div>
    </div>
  );
}

export default App;
